export default __webpack_public_path__ + "static/media/Ethereum.98250039.svg";